export default {
  registerApprovalList: {
    url: '/sys/set/role/registerApprovalList',
    method: 'post'
  },
  approval: {
    url: '/approval',
    method: 'post'
  },
  suppRegisterFileDownload: {
    url: '/suppRegisterFileDownload',
    method: 'post',
    responseType: 'blob'
  },
};